import { WrappedCheckboxDesktop as Checkbox } from '@alfa-bank/site-checkbox/checkbox-desktop';
import { RadioTagsDesktop as RadioTags } from '@alfa-bank/site-radio-tags/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget';

import { Fio as Component } from './fio';
import type { IDeps, TFioField } from './models';

export const FioField = createWidget<IDeps, TFioField>({
    Checkbox,
    RadioTags,
})(Component);
